import { render } from "./CreateUpdateReservasComponent.vue?vue&type=template&id=003d6dd0"
import script from "./CreateUpdateReservasComponent.vue?vue&type=script&lang=js"
export * from "./CreateUpdateReservasComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__